export const SeriesColorPalettes= [
  [
    "#1E78FF",
    "#03086E",
    "#20469B",
    "#7396F1",
    "#B2DBF3",
    "#ACB6BB",
    "#D2BE84",
    "#F79726",
    "#8BDAAB",
    "#56BCBE",
    "#8186F7",
    "#5B31D1",
    "#32195A",
    "#3874CB",
    "#8AD0EB",
    "#4090AF",
  ],
  [
    "#03086E",
    "#8D54F1",
    "#8980F2",
    "#56BCBE",
    "#BBEEF1",
    "#BD69D5",
    "#85065A",
    "#AFD3E5",
    "#FF9CA5",
    "#CB303E",
    "#8EC8E7",
    "#6CE7FC",
    "#3861F6",
    "#E3C864",
    "#E7E9A4",
    "#ACB6BB",
  ],
  [
    "#060850",
    "#1E78FF",
    "#00B08D",
    "#61C784",
    "#C4C679",
    "#E8CFAA",
    "#F79726",
    "#FF6363",
    "#CB303E",
    "#970D0D",
    "#550606",
    "#9E9888",
    "#ACB6BB",
    "#8A7EE9",
    "#906ACB",
    "#613CB0",
  ],
];